var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65 6.6C4.65 7.01 4.99 7.35 5.4 7.35C5.81 7.35 6.15 7.01 6.15 6.6C6.15 5.31 7.2 4.27 8.48 4.27C8.89 4.27 9.23 3.93 9.23 3.52C9.23 3.11 8.89 2.77 8.48 2.77C6.37 2.77 4.65 4.49 4.65 6.6Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33 15.34C6.19 17.03 7.52 18 9 18C10.48 18 11.81 17.03 12.67 15.34C12.86 14.97 12.71 14.52 12.34 14.33C11.97 14.14 11.52 14.29 11.33 14.66C10.74 15.83 9.89 16.5 9 16.5C8.11 16.5 7.26 15.83 6.67 14.66C6.48 14.29 6.03 14.14 5.66 14.33C5.29 14.52 5.14 14.97 5.33 15.34Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.75H0.75C0.34 15.75 0 15.41 0 15V13.5C0 13.3 0.08 13.11 0.22 12.97L2.25 10.94V6.75C2.25 3.03 5.28 0 9 0C12.72 0 15.75 3.03 15.75 6.75V10.94L17.78 12.97C17.92 13.11 18 13.3 18 13.5V15C18 15.41 17.66 15.75 17.25 15.75ZM1.5 14.25H16.5V13.81L14.47 11.78C14.33 11.64 14.25 11.45 14.25 11.25V6.75C14.25 3.86 11.89 1.5 9 1.5C6.11 1.5 3.75 3.86 3.75 6.75V11.25C3.75 11.45 3.67 11.64 3.53 11.78L1.5 13.81V14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.51e2bdcf499753e62f2cc4c6b7613bc5.svg";
export { ForwardRef as ReactComponent };